export function truncateToSingleDecimal(amount: number) {
	const hasMoreThanOneDecimal = amount.toString().split(".")[1]?.length > 1;

	return hasMoreThanOneDecimal ? Math.floor(amount * 10) / 10 : amount;
}
